import React, { useState } from 'react';
import { AppLayout } from './layouts/AppLayout';
import { BottomNav, TabId } from './components/BottomNav';
import { EmployeesPage } from './pages/EmployeesPage';
import { EmployeeProfilePage } from './pages/EmployeeProfilePage';
import { ScanPage } from './pages/ScanPage';
import { HistoryPage } from './pages/HistoryPage';
import { SyncPage } from './pages/SyncPage';
import { SettingsPage } from './pages/SettingsPage';
export function App() {
  const [activeTab, setActiveTab] = useState<TabId>('scan');
  const [selectedEmployeeId, setSelectedEmployeeId] = useState<string | null>(null);
  const handleTabChange = (tab: TabId) => {
    setActiveTab(tab);
    setSelectedEmployeeId(null); // Reset drill-down when changing tabs
  };
  const renderContent = () => {
    // Handle drill-down navigation for Employees tab
    if (activeTab === 'employees' && selectedEmployeeId) {
      return <EmployeeProfilePage onBack={() => setSelectedEmployeeId(null)} data-id="element-0" />;
    }
    switch (activeTab) {
      case 'employees':
        return <EmployeesPage onSelectEmployee={setSelectedEmployeeId} data-id="element-1" />;
      case 'scan':
        return <ScanPage data-id="element-2" />;
      case 'history':
        return <HistoryPage data-id="element-3" />;
      case 'sync':
        return <SyncPage data-id="element-4" />;
      case 'settings':
        return <SettingsPage data-id="element-5" />;
      default:
        return <ScanPage data-id="element-6" />;
    }
  };
  return <AppLayout activeTab={activeTab} onTabChange={handleTabChange} data-id="element-7">
      {renderContent()}
    </AppLayout>;
}